<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Rewards
      </div>
    </template>
  
    <div class="d-flex flex-column align-start" style="height: 100%">

      <RewardsTabs />

      <router-view class="mt-2 align-self-stretch" style="overflow-y: auto"/>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import RewardsTabs from './RewardsTabs'

export default {
  name: 'RewardsView',

  components: { ContentPage, RewardsTabs },
}
</script>
